<template>
  <transition
    :css="false"
    @enter="enter"
  >
    <slot />
  </transition>
</template>

<script>
import gsap from 'gsap'

export default {
  props: {
    config: {
      type: Object,
      default: () => ({}),
    },
  },
  methods: {
    enter(el, done) {
      gsap.from(
        el,
        this.config.duration || 0.25,
        {
          opacity: 0,
          onComplete: done,
        }
      )
    }
  },
}
</script>
